import { cn } from '@/core/utils/cn';

type BadgeVariant = 'default' | 'gold' | 'teal' | 'blue' | 'red' | 'green' | 'purple' | 'amber' | 'outline';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  dot?: boolean;
  id?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-white/5 text-hms-textSub',
  gold: 'bg-hms-gold/10 text-hms-gold',
  teal: 'bg-hms-teal/10 text-hms-teal',
  blue: 'bg-hms-blue/10 text-hms-blue',
  red: 'bg-hms-red/10 text-hms-red',
  green: 'bg-hms-green/10 text-hms-green',
  purple: 'bg-hms-purple/10 text-hms-purple',
  amber: 'bg-hms-amber/10 text-hms-amber',
  outline: 'bg-transparent border border-hms-border text-hms-textSub',
};

export function Badge({ children, variant = 'default', className, dot, id }: BadgeProps) {
  return (
    <span id={id} className={cn(
      'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-medium',
      variantStyles[variant],
      className
    )}>
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', variant === 'default' ? 'bg-hms-textDim' : 'bg-current')} />}
      {children}
    </span>
  );
}
